import { Alert } from '@indipia/ui-core';
import { fmtDateDowTime, fmtMonthDayKo } from './format';

interface Props {
  /** 직전 방문 시각 — 제목 날짜·하단 "마지막 열람"의 기준 */
  lastVisitedDtm: string;
  /** 새 소식 문구("현장리포트 2건" 등) — 호출부는 1개 이상일 때만 렌더한다 */
  parts: string[];
  onClose: () => void;
}

function BellIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
}

/**
 * 지난 방문 이후 새 소식 요약 배너. 새 소식이 있을 때만 호출부가 렌더한다.
 * 탭을 열람해도 문구는 그대로이고, 이번 방문 동안 [닫기]를 눌러야만 접힌다.
 */
export function NewsBanner({ lastVisitedDtm, parts, onClose }: Props) {
  return (
    <Alert
      kind="info"
      icon={<BellIcon />}
      title={`지난 방문(${fmtMonthDayKo(lastVisitedDtm)}) 이후 새 소식`}
      onClose={onClose}
      closeLabel="새 소식 안내 닫기"
      className="rounded-none border-x-0 border-t-0"
    >
      <div className="text-caption font-bold">{parts.join(' · ')}</div>
      <div className="mt-01 text-caption" style={{ color: 'var(--indipia-purple-500)' }}>
        마지막 열람 {fmtDateDowTime(lastVisitedDtm)}
      </div>
    </Alert>
  );
}
